module.exports = __webpack_public_path__ + "static/media/thumb.02d05293.jpg";